<template>
  <div class="personal-page">
    <!-- 左侧菜单栏 -->
    <div class="personal-sidebar">
      <div class="personal-logo" @click="goHome">
        <img
          class="personal-logo-img"
          src="./assets/img/logo.png"
          alt="logo"
        />
      </div>
      <div class="personal-menu">
        <div
          class="personal-menu-item"
          :class="{ 'personal-menu-item-active': activeMenu === 'publish' }"
          @click="switchMenu('publish')"
        >
          <span>发布文章</span>
        </div>
        <div
          class="personal-menu-item"
          :class="{ 'personal-menu-item-active': activeMenu === 'pending' }"
          @click="switchMenu('pending')"
        >
          <span>审核中的文章({{ articleCounts.auditCount }})</span>
        </div>
        <div
          class="personal-menu-item"
          :class="{ 'personal-menu-item-active': activeMenu === 'rejected' }"
          @click="switchMenu('rejected')"
        >
          <span>已驳回的文章({{ articleCounts.draftCount }})</span>
        </div>
        <div
          class="personal-menu-item"
          :class="{ 'personal-menu-item-active': activeMenu === 'published' }"
          @click="switchMenu('published')"
        >
          <span>已发布的文章({{ articleCounts.publishCount }})</span>
        </div>
        <div
          class="personal-menu-item"
          :class="{ 'personal-menu-item-active': activeMenu === 'commented' }"
          @click="switchMenu('commented')"
        >
          <span>我评论的文章({{ articleCounts.commentCount }})</span>
        </div>
        <div
          class="personal-menu-item"
          :class="{ 'personal-menu-item-active': activeMenu === 'favorite' }"
          @click="switchMenu('favorite')"
        >
          <span>我收藏的文章({{ articleCounts.favoriteCount }})</span>
        </div>
        <div
          class="personal-menu-item"
          :class="{ 'personal-menu-item-active': activeMenu === 'like' }"
          @click="switchMenu('like')"
        >
          <span>我点赞的文章({{ articleCounts.likeCount }})</span>
        </div>
        <div
          class="personal-menu-item"
          :class="{ 'personal-menu-item-active': activeMenu === 'feedback' }"
          @click="switchMenu('feedback')"
        >
          <span>反馈意见({{ articleCounts.feedbackCount }})</span>
        </div>
        <div
          class="personal-menu-item"
          :class="{ 'personal-menu-item-active': activeMenu === 'magazine' }"
          @click="switchMenu('magazine')"
        >
          <span>我的电子杂志</span>
        </div>
        <div
          class="personal-menu-item"
          :class="{ 'personal-menu-item-active': activeMenu === 'orders' }"
          @click="switchMenu('orders')"
        >
          <span>我的订单</span>
        </div>
        <div class="personal-menu-bottom">
          <div
            v-if="userType === 'personal'"
            class="personal-menu-item"
            :class="{ 'personal-menu-item-active': activeMenu === 'personal' }"
            @click="switchMenu('personal')"
          >
            <span>个人资料</span>
          </div>
          <div
            v-if="userType === 'company'"
            class="personal-menu-item"
            :class="{ 'personal-menu-item-active': activeMenu === 'company' }"
            @click="switchMenu('company')"
          >
            <span>企业信息</span>
          </div>
          <div class="personal-menu-item" @click="handleLogout">
            <span>退出</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 右侧内容 -->
    <div class="personal-main">
      <!-- 右侧顶部：标题 + 用户信息 -->
      <div class="personal-header">
        <div class="personal-header-title">{{ currentTitle }}</div>
        <div class="personal-header-user">
          <span class="personal-header-welcome">欢迎登录，{{ userName }}</span>
          <img
            class="personal-header-avatar"
            :src="userAvatar || require('./assets/img/FigmaDDSSlicePNGfa36507fbfa9e81fa8dec8ebee3005b7.png')"
            alt="avatar"
          />
        </div>
      </div>
      <!-- 右侧下方内容区 -->
      <div class="personal-content">
        <div v-if="contentLoading" class="personal-content-loading">
          <span>加载中...</span>
        </div>
        <PublishArticle
          v-if="activeMenu === 'publish'"
          :id="editArticleId"
          :auth-status="authStatus"
          :key="'publish-' + menuKey"
          @loaded="handleContentLoaded"
          @load-error="handleContentLoadError"
          @submit-success="handleSubmitSuccess"
        />
        <MyArticles v-else-if="activeMenu === 'pending' || activeMenu === 'rejected' || activeMenu === 'published' || activeMenu === 'commented' || activeMenu === 'favorite' || activeMenu === 'like'" :tab="activeMenu" :key="'articles-' + menuKey" @edit="handleEditArticle" @refresh="loadIndexInfo" @loaded="handleContentLoaded" @load-error="handleContentLoadError" />
        <Feedback v-else-if="activeMenu === 'feedback'" :key="'feedback-' + menuKey" @loaded="handleContentLoaded" @load-error="handleContentLoadError" />
        <MyMagazine v-else-if="activeMenu === 'magazine'" :key="'magazine-' + menuKey" @loaded="handleContentLoaded" @load-error="handleContentLoadError" />
        <MyOrders v-else-if="activeMenu === 'orders'" :key="'orders-' + menuKey" @loaded="handleContentLoaded" @load-error="handleContentLoadError" />
        <PersonalInfo v-else-if="activeMenu === 'personal'" :key="'personal-' + menuKey" @user-updated="loadWelcomeInfo" @loaded="handleContentLoaded" @load-error="handleContentLoadError" />
        <CompanyInfo v-else-if="activeMenu === 'company'" :key="'company-' + menuKey" @user-updated="loadWelcomeInfo" @loaded="handleContentLoaded" @load-error="handleContentLoadError" />
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { fetchUserInfo, fetchCompanyInfo, getMemberIndexInfo, getCompanyIndexInfo } from '../../api'
import MyArticles from './MyArticles.vue'
import MyMagazine from './MyMagazine.vue'
import MyOrders from './MyOrders.vue'
import Feedback from './Feedback.vue'
import PersonalInfo from './personal/PersonalInfo.vue'
import CompanyInfo from './company/CompanyInfo.vue'
import PublishArticle from './PublishArticle.vue'

export default {
  name: 'Personal',
  components: {
    MyArticles,
    MyMagazine,
    MyOrders,
    Feedback,
    PersonalInfo,
    CompanyInfo,
    PublishArticle
  },
  data() {
    const userType = localStorage.getItem('userType') || 'personal'
    return {
      activeMenu: userType === 'company' ? 'company' : 'personal',
      userType,
      userName: '赵小编',
      userAvatar: '',
      menuKey: 0,
      editArticleId: null,
      authStatus: 0,
      contentLoading: false,
      articleCounts: {
        auditCount: 0,
        draftCount: 0,
        publishCount: 0,
        likeCount: 0,
        favoriteCount: 0,
        commentCount: 0,
        feedbackCount: 0
      },
      titleMap: {
        publish: '发布文章',
        pending: '审核中的文章',
        rejected: '已驳回的文章',
        published: '已发布的文章',
        commented: '我评论的文章',
        favorite: '我收藏的文章',
        like: '我点赞的文章',
        feedback: '反馈意见',
        magazine: '我的电子杂志',
        orders: '我的订单',
        personal: '个人资料',
        company: '企业信息'
      }
    }
  },
  computed: {
    currentTitle() {
      return this.titleMap[this.activeMenu] || '工作台'
    }
  },
  created() {
    Toast.setDefaultOptions({ position: 'top' })
    this.loadWelcomeInfo()
    this.loadIndexInfo()
  },
  beforeDestroy() {
    Toast.resetDefaultOptions()
  },
  methods: {
    async loadWelcomeInfo() {
      if (this.userType === 'company') {
        try {
          const data = await fetchCompanyInfo()
          this.userName = data.companyShortName || data.companyName || '企业用户'
          this.userAvatar = data.avatar || ''
          this.authStatus = data.auditStatus || 0
        } catch (err) {
          // 接口失败保持默认
        }
      } else {
        try {
          const data = await fetchUserInfo()
          this.userName = data.nickname || this.userName
          this.userAvatar = data.avatar || ''
          this.authStatus = data.realNameStatus || 0
          const userInfoStr = localStorage.getItem('userInfo')
          const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}
          userInfo.nickname = data.nickname || userInfo.nickname
          userInfo.avatar = data.avatar || userInfo.avatar
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
        } catch (err) {
          // 接口失败保持默认
        }
      }
    },
    async loadIndexInfo() {
      try {
        const data = this.userType === 'company'
          ? await getCompanyIndexInfo()
          : await getMemberIndexInfo()
        this.articleCounts = {
          auditCount: data.auditCount || 0,
          draftCount: data.draftCount || 0,
          publishCount: data.publishCount || 0,
          likeCount: data.likeCount || 0,
          favoriteCount: data.favoriteCount || 0,
          commentCount: data.commentCount || 0,
          feedbackCount: data.feedbackCount || 0
        }
      } catch (err) {
        // 接口失败保持默认
      }
    },
    switchMenu(menu) {
      if (menu === 'publish') {
        const isAuth = this.authStatus === 2
        if (!isAuth) {
          const message = this.userType === 'company'
            ? '没有进行企业认证无法发布文章'
            : '没有进行实名认证无法发布文章'
          Dialog.alert({
            title: '提示',
            message
          }).then(() => {}).catch(() => {})
        }
      }
      this.activeMenu = menu
      this.menuKey++
      this.contentLoading = true
    },
    handleContentLoaded() {
      this.contentLoading = false
    },
    handleContentLoadError() {
      this.contentLoading = false
      this.$router.replace({ name: 'not-found' })
    },
    handleSubmitSuccess() {
      this.editArticleId = null
      this.switchMenu('pending')
      this.loadIndexInfo()
    },
    handleEditArticle(item) {
      this.editArticleId = item.id || null
      this.switchMenu('publish')
    },
    handleLogout() {
      Dialog.confirm({
        title: '提示',
        message: '是否退出登录？',
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('userType')
        localStorage.removeItem('userInfo')
        this.$router.push('/')
      }).catch(() => {})
    },
    goHome() {
      this.$router.push('/')
      this.activeMenu = 'pending'
    }
  }
}
</script>

<style lang="css" src="./assets/personal.css" />
